import { render, staticRenderFns } from "./ClaimInformation.vue?vue&type=template&id=fad222ce&"
import script from "./ClaimInformation.vue?vue&type=script&lang=js&"
export * from "./ClaimInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports